import { render, staticRenderFns } from "./StatTaskContent.vue?vue&type=template&id=4179ca1e&scoped=true&"
import script from "./StatTaskContent.vue?vue&type=script&lang=ts&"
export * from "./StatTaskContent.vue?vue&type=script&lang=ts&"
import style0 from "./StatTaskContent.vue?vue&type=style&index=0&id=4179ca1e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4179ca1e",
  null
  
)

export default component.exports